import { useBiLogger } from "./hooks/use-bi-logger";
import { appMarketSaleBannerImpressionWebMobile, } from "@wix/bi-logger-app-market-data/v2";
import { useMemo } from "react";
export const useManageAppsBi = () => {
    const biLogger = useBiLogger();
    return useMemo(() => ({
        appMarketSaleBannerBI: ({ msid, origin, actionType, }) => {
            biLogger.report(appMarketSaleBannerImpressionWebMobile({
                sale_name: "nov-25",
                tag_type: "manage_apps",
                msid,
                market: origin,
                action_type: actionType,
            }));
        },
    }), [biLogger]);
};
//# sourceMappingURL=useManageAppsBi.js.map